
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';

// Internal
import { Loading, GruppoDistinteConsumiList, LoadingTemplateType } from '@/components';
import { OrdineSlim, Utente, ItemDatiLookup, FinderDistinteStatiche } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import dayjs from 'dayjs';

@Component({
  components: {
    Loading,
    GruppoDistinteConsumiList
  }
})
export default class Consumi extends Vue {

  private filtroDaValidare = false;
  private filtroDraft = false;
  private filtroValidSync = false;

  private stagione: string = '';
  private filtroAvanzamento: string[] = [];

  private modello: string = '';
  private colore: string = '';
  private lineaVendita: string = '';

  private menu1: boolean = false;
  private menu2: boolean = false;
  private filtroVariazioniDa: string = '';
  private filtroVariazioniDaFormatted: string = '';
  private filtroVariazioniA: string = '';
  private filtroVariazioniAFormatted: string = '';

  get loading() { return store.state.loading; }
  get user() { return store.state.currentUsr; }
  get userIsAdmin() { return (this.user.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined); }

  get pageSize(): number { return store.state.ui.dimensionePaginaListe; }
  get page(): number { return store.state.uiConsumi.pagina; }
  set page(value: number) { this.caricaPaginaDistinteConsumi(value); }

  get pageCount(): number { return store.state.uiConsumi.totPagine; }
  get numTotDistinte(): number { return store.state.uiConsumi.totItems; }

  get stagioni(): ItemDatiLookup[] { 
    var stagioni: ItemDatiLookup[] = [];

    if(store.state.datiLookup && store.state.datiLookup.stagioni) {
      stagioni = store.state.datiLookup.stagioni;
    }

    return stagioni;
  }
  get lineeVendita(): ItemDatiLookup[] { 
    var lineeVendita: ItemDatiLookup[] = [];

    if(store.state.datiLookup && store.state.datiLookup.lineeVendita) {
      lineeVendita = store.state.datiLookup.lineeVendita;
    }

    return lineeVendita;
  }
  get avanzamenti(): ItemDatiLookup[] { 
    var avanzamenti: ItemDatiLookup[] = [];

    if(store.state.datiLookup && store.state.datiLookup.tipologieAvanzamentoProduzione) {
      avanzamenti = store.state.datiLookup.tipologieAvanzamentoProduzione;
    }

    return avanzamenti;
  }

  get loadTemplateCorrente() : LoadingTemplateType {
    return LoadingTemplateType.Consumi;
  }

  // private onModelloChange(modelloInput: string) {
  //   this.modello = modelloInput;
  // }

  get btnRefreshDisabled(): boolean {
    var opt1 = this.modello != undefined && this.modello.length > 0;
    var opt2 = this.colore != undefined && this.colore.length > 0;
    var opt3 = this.stagione != undefined && this.stagione.length > 0;
    var opt4 = this.filtroAvanzamento != undefined && this.filtroAvanzamento.length > 0;
    var opt5 = this.lineaVendita != undefined && this.lineaVendita.length > 0;

    return !(opt1 || opt2 || opt3 || opt4 || opt5 || this.filtroDaValidare === true || this.filtroDraft === true || this.filtroValidSync === true);
  }  

  private caricaPaginaDistinteConsumi(pagina: number): void {

    const finder = new FinderDistinteStatiche(pagina);

    if(this.stagione != undefined && this.stagione.trim().length > 0) {
      finder.filtroStagioni.push(this.stagione.trim());
    }
    if(this.filtroAvanzamento != undefined && this.filtroAvanzamento.length > 0) {
      finder.filtroAvanzamentiProduzione = this.filtroAvanzamento;
    }
    if(this.modello != undefined && this.modello.trim().length > 0) {
      finder.filtroModelli.push(this.modello.trim());
    }
    if(this.colore != undefined && this.colore.trim().length > 0) {
      finder.filtroColori.push(this.colore.trim());
    }
    if(this.lineaVendita != undefined && this.lineaVendita.trim().length > 0) {
      finder.filtroLineaVendita.push(this.lineaVendita.trim());
    }
    let dataDa = dayjs(this.filtroVariazioniDa, { utc: true });
    if(dataDa.isValid()) {
        finder.filtroVariazioniDaData = dataDa.toDate();
    }

    let dataA = dayjs(this.filtroVariazioniA, { utc: true });
    if(dataA.isValid()) {
        finder.filtroVariazioniAData = dataA.toDate();
    }
    finder.soloDistinteDaValidare = this.filtroDaValidare;
    finder.soloDistinteInDraft = this.filtroDraft;
    finder.soloDistinteValidateESincronizzate = this.filtroValidSync;

    store.commit(StoreMutations.SetFiltriDistinteConsumi, finder);
    // store.dispatch(StoreActions.GetDistinteConsumiBC, finder);
    store.dispatch(StoreActions.GetGruppiDistinteConsumiBC, finder);
  }

  @Watch('filtroVariazioniDa')
  onDataDaChange(): void {
      this.filtroVariazioniDaFormatted = this.formatDate(this.filtroVariazioniDa)
  }

  @Watch('filtroVariazioniA')
  onDataAChange(): void {
      this.filtroVariazioniAFormatted = this.formatDate(this.filtroVariazioniA)
  }

  formatDate (date: string): string {
      if (!date) return '';

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
  }

  parseDate (date: string): string {
      if (!date) return '';

      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

}
